import { isHTMLElement } from './dom.esm.js';

var isActiveElement = function isActiveElement(element) {
  return document.activeElement === element;
};
function ensureFocus(element, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$isActive = _ref.isActive,
      isActive = _ref$isActive === void 0 ? isActiveElement : _ref$isActive,
      preventScroll = _ref.preventScroll;

  if (isActive(element)) return -1;
  return requestAnimationFrame(function () {
    element.focus({
      preventScroll: preventScroll
    });
  });
}
function isInputElement(element) {
  return isHTMLElement(element) && element.tagName.toLowerCase() === 'input' && 'select' in element;
}
var hasTabIndex = function hasTabIndex(element) {
  return element.hasAttribute('tabindex');
};
var hasNegativeTabIndex = function hasNegativeTabIndex(element) {
  return hasTabIndex(element) && element.tabIndex === -1;
};
function isDisabled(element) {
  return Boolean(element.getAttribute('disabled')) === true || Boolean(element.getAttribute('aria-disabled')) === true;
}
function isHidden(element) {
  if (element.parentElement && isHidden(element.parentElement)) return true;
  return element.hidden;
}
function isContentEditable(element) {
  var value = element.getAttribute('contenteditable');
  return value !== 'false' && value != null;
}
function isFocusable(element) {
  if (!isHTMLElement(element) || isHidden(element) || isDisabled(element)) {
    return false;
  }

  var localName = element.localName;
  var focusableTags = ['input', 'select', 'textarea', 'button'];
  if (focusableTags.indexOf(localName) >= 0) return true;
  var others = {
    a: function a() {
      return element.hasAttribute('href');
    },
    audio: function audio() {
      return element.hasAttribute('controls');
    },
    video: function video() {
      return element.hasAttribute('controls');
    }
  };

  if (localName in others) {
    return others[localName]();
  }

  if (isContentEditable(element)) return true;
  return hasTabIndex(element);
}
function isTabbable(element) {
  if (!element) return false;
  return isHTMLElement(element) && isFocusable(element) && !hasNegativeTabIndex(element);
}

export { ensureFocus, hasNegativeTabIndex, hasTabIndex, isActiveElement, isContentEditable, isDisabled, isFocusable, isHidden, isInputElement, isTabbable };
//# sourceMappingURL=tabbable.esm.js.map
